module.exports = __webpack_public_path__ + "img/tianshine_2.bf40d443.png";